import React from 'react';
import { CheckCircle, Clock, XCircle } from '@phosphor-icons/react';
import { STATUS_TONE, formatDateTime } from './constants';

const TimelineItem = ({ item, isLast }) => {
  const tone = STATUS_TONE[item.status] || STATUS_TONE.pending;
  const Icon =
    item.status === 'rejected'
      ? XCircle
      : item.status === 'completed'
        ? CheckCircle
        : Clock;
  return (
    <div className="flex gap-4">
      <div className="flex flex-col items-center">
        <div className={`w-3 h-3 rounded-full ${tone.dot} ring-4 ${tone.ring}`} />
        {!isLast && <div className="flex-1 w-px bg-slate-200 mt-1" />}
      </div>
      <div className="flex-1 pb-6">
        <div className="flex items-center gap-2 mb-1">
          <Icon size={16} className={tone.text} weight="fill" />
          <span className="font-semibold text-slate-900 text-sm">{item.milestone}</span>
          {item.timestamp && (
            <span className="text-xs text-slate-400 ml-auto whitespace-nowrap">
              {formatDateTime(item.timestamp)}
            </span>
          )}
        </div>
        {item.details && (
          <p className="text-xs text-slate-600 leading-relaxed">{item.details}</p>
        )}
        {item.filename && (
          <p
            className="font-mono text-[11px] text-slate-400 mt-1 truncate"
            title={item.filename}
          >
            {item.filename}
          </p>
        )}
      </div>
    </div>
  );
};

export default TimelineItem;
